import { ALERT__ADD, ALERT__REMOVE, ALERT__DELETE } from '../actions';
const initialState = {
  alertsList: [],
  alertsRemoved: []
};
export default (function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ALERT__ADD:
      return {
        ...state,
        alertsList: state.alertsList.concat([action.payload])
      };
    case ALERT__REMOVE:
      return {
        ...state,
        alertsRemoved: state.alertsRemoved.concat([action.payload])
      };
    case ALERT__DELETE:
      return {
        ...state,
        alertsList: state.alertsList.filter(a => a.id !== action.payload),
        alertsRemoved: state.alertsList.filter(a => a.id !== action.payload)
      };
    default:
      return state;
  }
});